/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentDeclineCode = {
    approve_with_id: 'approve_with_id',
    authentication_required: 'authentication_required',
    call_issuer: 'call_issuer',
    card_not_supported: 'card_not_supported',
    card_velocity_exceeded: 'card_velocity_exceeded',
    currency_not_supported: 'currency_not_supported',
    do_not_honor: 'do_not_honor',
    do_not_try_again: 'do_not_try_again',
    duplicate_transaction: 'duplicate_transaction',
    expired_card: 'expired_card',
    fraudulent: 'fraudulent',
    generic_decline: 'generic_decline',
    incorrect_cvc: 'incorrect_cvc',
    incorrect_number: 'incorrect_number',
    incorrect_pin: 'incorrect_pin',
    incorrect_zip: 'incorrect_zip',
    insufficient_funds: 'insufficient_funds',
    invalid_account: 'invalid_account',
    invalid_amount: 'invalid_amount',
    invalid_cvc: 'invalid_cvc',
    invalid_expiry_month: 'invalid_expiry_month',
    invalid_expiry_year: 'invalid_expiry_year',
    invalid_number: 'invalid_number',
    invalid_pin: 'invalid_pin',
    issuer_not_available: 'issuer_not_available',
    lost_card: 'lost_card',
    merchant_blacklist: 'merchant_blacklist',
    new_account_information_available: 'new_account_information_available',
    no_action_taken: 'no_action_taken',
    not_permitted: 'not_permitted',
    offline_pin_required: 'offline_pin_required',
    online_or_offline_pin_required: 'online_or_offline_pin_required',
    pickup_card: 'pickup_card',
    pin_try_exceeded: 'pin_try_exceeded',
    processing_error: 'processing_error',
    reenter_transaction: 'reenter_transaction',
    restricted_card: 'restricted_card',
    revocation_of_all_authorizations: 'revocation_of_all_authorizations',
    revocation_of_authorization: 'revocation_of_authorization',
    security_violation: 'security_violation',
    service_not_allowed: 'service_not_allowed',
    stolen_card: 'stolen_card',
    stop_payment_order: 'stop_payment_order',
    testmode_decline: 'testmode_decline',
    transaction_not_allowed: 'transaction_not_allowed',
    try_again_later: 'try_again_later',
    withdrawal_count_limit_exceeded: 'withdrawal_count_limit_exceeded'
} as const;
export type PaymentDeclineCode = typeof PaymentDeclineCode[keyof typeof PaymentDeclineCode];


export function PaymentDeclineCodeFromJSON(json: any): PaymentDeclineCode {
    return PaymentDeclineCodeFromJSONTyped(json, false);
}

export function PaymentDeclineCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDeclineCode {
    return json as PaymentDeclineCode;
}

export function PaymentDeclineCodeToJSON(value?: PaymentDeclineCode | null): any {
    return value as any;
}

